import { saveAs } from 'file-saver';
import { formatCentsToUsd } from '../../../helpers/formatCentsToUsd';
import { centsToXlsxNumber, applyCurrencyFormat } from '../../../helpers/excelExportHelpers';

export const exportAffiliateAgentReportToXlsx = async (reportData, dateFrom, dateTo) => {
    const XLSX = await import('xlsx');
    const fileType =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const sheetData = [];

    const formatDateLabel = (value) => {
        if (!value) return null;
        const parsed = new Date(`${value}T12:00:00`);
        return Number.isNaN(parsed.getTime()) ? null : parsed.toLocaleDateString();
    };
    const fromLabel = formatDateLabel(dateFrom);
    const toLabel = formatDateLabel(dateTo);
    const rangeLabel =
        fromLabel && toLabel ? `${fromLabel} - ${toLabel}` : fromLabel || toLabel || 'All dates';

    sheetData.push(['Affiliate Agent Performance Report']);
    sheetData.push([`Date Range: ${rangeLabel}`]);
    sheetData.push([
        `Total Sales: ${formatCentsToUsd(reportData.totalSales || 0)}`,
        `Total Bookings: ${reportData.totalBookings || 0}`,
    ]);
    sheetData.push([]);

    sheetData.push(['Agent', 'Commission Group', 'Bookings', 'Total Sales', '% of Total']);

    (reportData.items || []).forEach((item) => {
        sheetData.push([
            item.agentName || '-',
            item.commissionGroupName || 'No group',
            item.bookingCount,
            centsToXlsxNumber(item.totalSales),
            typeof item.percentageOfTotal === 'number' ? item.percentageOfTotal : '',
        ]);
    });

    const totalSales = reportData.totalSales || 0;
    sheetData.push([
        'Grand Total',
        '',
        reportData.totalBookings || 0,
        centsToXlsxNumber(totalSales),
        totalSales === 0 ? 0 : 100,
    ]);

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws['!cols'] = [{ wch: 30 }, { wch: 24 }, { wch: 12 }, { wch: 15 }, { wch: 12 }];
    // Total Sales (col 3) as currency, % of Total (col 4) as a percent.
    applyCurrencyFormat(XLSX, ws, sheetData, [3]);
    applyCurrencyFormat(XLSX, ws, sheetData, [4], '0.00"%"');

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Affiliate Agent Report');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const file = new Blob([excelBuffer], { type: fileType });

    const filenameRange =
        dateFrom && dateTo ? `${dateFrom}-to-${dateTo}` : dateFrom || dateTo || 'all-dates';
    const filename = `affiliate-agent-report-${filenameRange}${fileExtension}`;
    saveAs(file, filename);
};

export default exportAffiliateAgentReportToXlsx;
